import { View } from '@/styles/reactnative';
import { useWindowDimensions } from '@app/hooks';
import React, { useMemo } from 'react';
import CBottomSheet from '../../../../../../components/Common/CBottomSheet';
import { useTradeSetting } from '../../../../../../hooks/trade/tradeSetting';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import { useTradePosition } from '../../../../../../hooks/trade/tradePosition';
import CrossModalContent from './CrossModalContent';
import { CrossModalWrapper } from './styles';
import { useIsMobile } from '@/utils/CalVW';

interface CrossModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
}

const CrossModal = ({ showModal, setShowModal }: CrossModalProps) => {
  const { width } = useWindowDimensions();
  const isMobile = useIsMobile();

  const wSize =
    width < 772
      ? width / 1.1
      : width < 1400
        ? width < 900
          ? width / 2
          : width / 3
        : width / 4;

  const { data: tradeStore } = useTradeStore();
  const { data: tradeSetting } = useTradeSetting(tradeStore.ep_id);
  const { data: positions } = useTradePosition();

  // 현재 종목의 포지션이 있으면 해당 포지션의 설정 사용
  const currentPosition = useMemo(() =>
    positions?.find((pos: any) => +pos.exchange_pairs_id === +tradeStore?.ep_id),
    [positions, tradeStore?.ep_id]
  );

  const initialCrossIso = currentPosition?.cross_iso ?? tradeSetting?.cross_iso;
  const initialLeverage = currentPosition?.leverage ?? tradeSetting?.leverage;

  const closeModal = () => setShowModal(false);

  // 모바일: CBottomSheet 사용
  if (isMobile) {
    return (
      <CBottomSheet
        isOpen={showModal}
        onClose={closeModal}
        height="auto"
      >
        <View style={{ padding: '12px 12px 24px 12px' }}>
          <CrossModalContent
            closeModal={closeModal}
            initialCrossIso={initialCrossIso}
            initialLeverage={initialLeverage}
          />
        </View>
      </CBottomSheet>
    );
  }

  // 데스크톱: 기존 모달 사용
  if (!showModal) return null;

  return (
    <CrossModalWrapper style={{ width: wSize }}>
      <CrossModalContent
        closeModal={closeModal}
        initialCrossIso={initialCrossIso}
        initialLeverage={initialLeverage}
      />
    </CrossModalWrapper>
  );
};

export default React.memo(CrossModal);
